/**
 * @generated SignedSource<<e85042c4b366c51c5a4f7a64137fb8ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DispatchConditionKind = "AccountDispatchCondition" | "AllUserDispatchCondition" | "OptInDispatchCondition" | "TreeFinishedDispatchCondition" | "TreeStartedDispatchCondition" | "TreeUnlockedDispatchCondition" | "UserDispatchCondition";
import { FragmentRefs } from "relay-runtime";
export type dispatchConditionDropdown_MessageDispatchFragment$data = {
  readonly excludes: ReadonlyArray<{
    readonly kind?: DispatchConditionKind;
    readonly rootNodeIds?: ReadonlyArray<string>;
    readonly userIds?: ReadonlyArray<string>;
    readonly " $fragmentSpreads": FragmentRefs<"removeDispatchConditionButton_DispatchConditionFragment">;
  }>;
  readonly id: string;
  readonly includes: ReadonlyArray<{
    readonly kind?: DispatchConditionKind;
    readonly rootNodeIds?: ReadonlyArray<string>;
    readonly userIds?: ReadonlyArray<string>;
    readonly " $fragmentSpreads": FragmentRefs<"removeDispatchConditionButton_DispatchConditionFragment">;
  }>;
  readonly " $fragmentType": "dispatchConditionDropdown_MessageDispatchFragment";
};
export type dispatchConditionDropdown_MessageDispatchFragment$key = {
  readonly " $data"?: dispatchConditionDropdown_MessageDispatchFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"dispatchConditionDropdown_MessageDispatchFragment">;
};

import dispatchConditionDropdown_Refetch_graphql from './dispatchConditionDropdown_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "removeDispatchConditionButton_DispatchConditionFragment"
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootNodeIds",
    "storageKey": null
  },
  (v0/*: any*/),
  (v1/*: any*/)
],
v4 = [
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "AccountDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "AllUserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
      },
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "type": "UserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeStartedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeFinishedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeUnlockedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "OptInDispatchCondition",
    "abstractKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": dispatchConditionDropdown_Refetch_graphql,
      "identifierField": "id"
    }
  },
  "name": "dispatchConditionDropdown_MessageDispatchFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "includes",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "excludes",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MessageDispatch",
  "abstractKey": null
};
})();

(node as any).hash = "05e9a1ad43ce5afc58e1753472f4c08b";

export default node;
